import { elementConstants } from "../../constants/cms/form/element/element.constants";
import { defaultPreConfirmationElement, defaultProfileImageUploaderElement } from "../models/defaultElements";
import { securityHelper } from "../../helpers/securityHelper";

export const profileImageUploaderHelper = {
    create
};

function getNewId(elements) {
    const preConfirmations =
        elements.filter(el => el.type === elementConstants.PROFILEIMAGE_UPLOAD)
        ;

    if (!preConfirmations.length || preConfirmations.length < 0) {
        return 0;
    }

    return preConfirmations.length * -1;
}

function create(
    source,
    sourceType,
    selectedEl,
    sortOrder
) {

    let eventId = source.eventId;
    let langCode = source.languageCode;
    let elements = source.formElements;;
    let currentPage = source.currentPage;
    let formId = source.formId;
    let pageId = null;

    let newEl = Object.assign({}, defaultProfileImageUploaderElement);
    newEl.sortOrder = sortOrder;
    newEl.formId = formId;
    newEl.eventId = eventId;
    newEl.parentId = null;
    newEl.pageId = pageId;
    newEl.id = getNewId(elements);
    newEl.languageCode = langCode;
    newEl.contentId = securityHelper.createGuid();
    newEl.page = currentPage;
    newEl.isValid = true;

    return newEl;
}